module.exports = __webpack_public_path__ + "img/gateio-view-small.3ea3d84d.png";